module.exports = __webpack_public_path__ + "static/colloidle-ded6c2f6186b244d83d38f0af0d3f0af.png";